import { container } from "tsyringe";
export class UseCasePostProductData {
    async handle(data) {
        const postProductData = container.resolve("iPostProductData");
        const productData = await postProductData.handle(data);
        return productData;
    }
}
